import { useState, useEffect } from 'react';
import axios from 'axios';
import Main from '../../../component/Main.jsx';
import WholeLoading from '../../../component/common/loading/WholeLoading.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';
import Pagination from '../../../component/common/dataGrid/Pagination.jsx';
import useModalStore from '../../../zustand/store/useModalStore.js';

import '../../../css/data-grid.css';
import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import * as Icons from '../../../images/icons/icons_component.js';

const OEBdExceptionAsk = () => {
    const [isSearched, setIsSearched] = useState(false);
    const [isWholeLoading, setIsWholeLoading] = useState(false);
    const [checkItems, setCheckItems] = useState([]);
    const [dataList, setDataList] = useState([]);

    const [pageInfo, setPageInfo] = useState({
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0,
    });

    const [searchParams, setSearchParams] = useState({
        searchFromdate: '',
        searchTodate: '',
        searchEmog: '',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        pageNum: 1,
        displayRowsize: 50,
    });

    const [exceptionParams, setExceptionParams] = useState({
        arrayExcepSeq: [],
        emmkMemo: '',
    });

    useEffect(() => {
        const init = async () => {
            setIsWholeLoading(true);
            const { fromDate, toDate } = await getDefaultSearchDays();
            setSearchParams(prev => ({ ...prev, searchFromdate: fromDate, searchTodate: toDate }));
            setIsWholeLoading(false);
        };
        init();
    }, []);

    useEffect(() => {
        setSearchParams(prev => ({
            ...prev,
            pageNum: pageInfo.currentPage,
            displayRowsize: pageInfo.itemsPerPage,
        }));
        if (isSearched) fetchData();
    }, [pageInfo.currentPage, pageInfo.itemsPerPage]);

    const getDefaultSearchDays = async () => {
        try {
            const today = new Date();
            const currentDay = today.getDay(); // 0 (Sun) ~ 6 (Sat)
            const start = new Date(today);
            start.setDate(today.getDate() - currentDay - 20);
            const end = new Date(today);
            end.setDate(today.getDate() - currentDay - 14);

            const { data } = await axios.post('/ptmiapi/sendweb/selectHolidayEMMK.do');
            if (data?.BNDSTTDT && data?.BNDENDDT) {
                return {
                    fromDate: formatDate(data.BNDSTTDT),
                    toDate: formatDate(data.BNDENDDT),
                };
            }
            return {
                fromDate: formatDateObj(start),
                toDate: formatDateObj(end),
            };
        } catch (error) {
            console.error('날짜 계산 오류:', error);
            return { fromDate: '', toDate: '' };
        }
    };

    const formatDate = (str) => {
        return `${str.substring(0, 4)}-${str.substring(4, 6)}-${str.substring(6, 8)}`;
    };

    const formatDateObj = (date) => {
        const y = date.getFullYear();
        const m = `${date.getMonth() + 1}`.padStart(2, '0');
        const d = `${date.getDate()}`.padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams(prev => ({ ...prev, [name]: value }));
        if (name === 'emmkMemo') {
            setExceptionParams(prev => ({ ...prev, emmkMemo: value }));
        }
    };

    // toast modal open function
    const showNotiModal = useModalStore(state => state.showNotiModal);

    const handleSearch = () => {
        if (!searchParams.searchEmog) {
            showNotiModal("먼저 해당 응급의료기관을 선택해주세요!");
            return;
        }
        setIsSearched(true);
        setPageInfo(prev => ({
            ...prev,
            currentPage: 1,
        }));
        fetchDataCount();
        fetchData();
    };
    
    const fetchData = async () => {
        try {
            setIsWholeLoading(true);
            const { data } = await axios.get('/trmsapi/sendweb/selectEMIMEMMKList2.do', { params: searchParams });
            setDataList(data);
        } catch (err) {
            console.error('데이터 로딩 오류:', err);
        } finally {
            setIsWholeLoading(false);
        }
    };

    const fetchDataCount = async () => {
        try {
            const { data } = await axios.get('/trmsapi/sendweb/selectEMIMEMMKList2_Cnt.do', { params: searchParams });
            setPageInfo(prev => ({ ...prev, totalItems: data }));
        } catch (err) {
            console.error('카운트 로딩 오류:', err);
        }
    };

    const handleAllCheck = (checked) => {
        setCheckItems(checked ? [...dataList] : []);
    };

    const handleSingleCheck = (checked, item) => {
        setCheckItems(prev =>
            checked ? [...prev, item] : prev.filter(ci => ci.SEQ !== item.SEQ)
        );
    };

    const handlePerPageChange = (e) => {
        setPageInfo(prev => ({ ...prev, itemsPerPage: parseInt(e.target.value) }));
    };

    const exceptionList = (items) =>
        items.map(el => `${el.ERROEMCD}|${el.ERROIDNO}|${el.ERROINDT}|${el.ERROINTM}|${el.ERROWRDT}|*`);

    const handleExceptionSubmit = async () => {
        if (checkItems.length === 0) {
            showNotiModal("예외전송 신청을 처리할 항목을 선택해주세요!");
            return;
        } else {
            const confirmed = window.confirm("예외신청을 진행하시겠습니까?");
            if (!confirmed) {
                // 취소 누르면 함수 종료
                return;
            }
            try {
                const { data } = await axios.post('/trmsapi/sendweb/OEexceptAskProc.do', {
                    arrayExcepSeq: exceptionList(checkItems),
                    emmkMemo: exceptionParams.emmkMemo,
                    userId: localStorage.getItem("id"),
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                if (!data.hasError) {
                    alert(data.resultMessage);
                    setCheckItems([]);
                    handleSearch();
                } else {
                    alert(data.resultMessage);
                    return;
                }
            } catch (error) {
                if (error.response && error.response.status === 500) {
                    // 서버가 에러 메시지를 응답한 경우
                    const message = error.response.data?.message || "서버 내부 오류가 발생했습니다.";
                    alert(`오류: ${message}`);
                } else {
                    const errMsg =
                        error.response.data?.message || // JSON 형식일 경우
                        error.response.data ||          // 텍스트 형식일 경우
                        "알 수 없는 오류가 발생했습니다.";
                    alert(`오류: ${errMsg}`);
                }
                console.error('예외 요청 중 오류:', error);
            }
        }
    };

    const perPageOptions = Array.from({ length: 10 }, (_, i) => (i + 1) * 10);
    const tableHeaders = ['No', '구분', '기관명', '등록번호', '내원일자', '내원시간', '퇴실일자', '퇴실시간', '퇴원일자', '퇴원시간'];
    const tableFields = ['SEQ', 'EMMKGUBN', 'EMOGDESC', 'PTMIMASK', 'PTMIINDT', 'PTMIINTM', 'PTMIOTDT', 'PTMIOTTM', 'PTMIDCDT', 'PTMIDCTM'];

    // Dynamic Style Hook
    const { fontColor, primaryBackColor, lightBackColor, borderColorGray } = useDynamicStyle();

    return (
        <Main>
            {isWholeLoading && <WholeLoading />}
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="25%" />
                        <col width="7%" />
                        <col width="19%" />
                        <col width="10%" />
                        <col width="19%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                exValidation={true}
                            />
                        </tr>
                        <tr>
                            <th>퇴실/퇴원일자</th>
                            <td>
                                <input type="date" name="searchFromdate" value={searchParams.searchFromdate} disabled className="calendar width_70" />
                                &nbsp;~&nbsp;
                                <input type="date" name="searchTodate" value={searchParams.searchTodate} disabled className="calendar width_70" />
                            </td>
                            <th>등록번호</th>
                            <td>
                                <input type="text" id='searchIdno' name="searchIdno" value={searchParams.searchIdno} onChange={handleInputChange} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className='search_btn_wrapper'>
                <div className='flex wp-60'>
                    <div className='flex w-full items-center gap-2'>
                        <span className='w-20'>[신청 사유]</span>
                        <input type="text" className='h-7' name="emmkMemo" value={exceptionParams.emmkMemo} onChange={handleInputChange} />
                        <button onClick={handleExceptionSubmit} className='search_btn bg_tr_primary w-16'>저장</button>
                    </div>
                </div>
                <div className='btn_container'>
                    <select name="itemsPerPage" value={pageInfo.itemsPerPage} onChange={handlePerPageChange}>
                        {perPageOptions.map(opt => <option key={opt} value={opt}>-- {opt}건 씩 조회 --</option>)}
                    </select>
                    <button onClick={handleSearch} disabled={isWholeLoading ? 'disabled' : ''} className={`search_btn ${primaryBackColor}`}><Icons.Search16w />검색</button>
                </div>
            </div>
            <div className='total_items mb-2'>전체&nbsp;<strong className={fontColor}>{pageInfo.totalItems}</strong>건</div>

            <div className='data_grid_container'>
                <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                <div className='data_list_table' style={{ maxHeight: '28rem' }}>
                    <table className={borderColorGray}>
                        <thead>
                            <tr>
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={dataList.length > 0 && checkItems.length === dataList.length}
                                        onChange={(e) => handleAllCheck(e.target.checked)}
                                    />
                                </th>
                                {tableHeaders.map((h, i) => <th key={i}>{h}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {dataList.length === 0 ? (
                                <tr>
                                    <td colSpan={1000} className='empty_box'>
                                        <span className={`data_empty ${lightBackColor}`}>
                                            {isSearched ? <Icons.EmptyDalgu /> : <Icons.NullDalgu />}
                                            {isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                        </span>
                                    </td>
                                </tr>
                            ) : (
                                dataList.map((item, index) => {
                                    const gridColor = index % 2 === 0 ? lightBackColor : '';
                                    return (
                                        <tr key={index} className={gridColor}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={checkItems.some(ci => ci.SEQ === item.SEQ)}
                                                    onChange={(e) => handleSingleCheck(e.target.checked, item)}
                                                />
                                            </td>
                                            {tableFields.map((field, i) => <td key={i}>{item[field]}</td>)}
                                        </tr>
                                    )
                                })
                            )}
                        </tbody>
                    </table>
                </div>
                <hr className='mr-1-1 co_border_gray' />
            </div>

            {dataList.length > 0 && <Pagination paginationInfo={{ ...pageInfo, onPageChange: handlePerPageChange }} />}

            <div className='mt-2'>
                <p className='co_red bold'> ※ 예외 전송 허용 기준</p>
                <p>○ 신청대상: (퇴실 또는 퇴원일 기준)최초 전송 가능 기간을 초과한 데이터로 3주전 월요일부터 일요일까지의 데이터</p>
                <p>○ 신청기간: 매주 월요일 00:00 ~ 목요일 13:00</p>
                <p>○ 전송 가능기간: 매주 목요일 00:00 ~ 23:59</p>
            </div>
        </Main>
    );
}

export default OEBdExceptionAsk;